import { render, staticRenderFns } from "./CadastroCliente.vue?vue&type=template&id=64d5de77&"
import script from "./CadastroCliente.vue?vue&type=script&lang=js&"
export * from "./CadastroCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports